import React from "react";
import { FieldArray, Form, Formik } from "formik";
import { FormContextDataProvider } from "./context";
import { FormContainerProps } from "./types";

/**
 * @name FormContainer
 * @description Formik wrapper
 * @param props
 * @constructor
 */
export default function FormContainer(props: FormContainerProps) {
  return (
    <FormContextDataProvider data={{ isReadOnly: false }}>
      {/* replace false with props.isReadOnly */}
      <Formik
        innerRef={props.innerRef}
        validateOnBlur={props.validateOnBlur !== undefined ? props.validateOnBlur : true}
        validateOnChange={props.validateOnChange !== undefined ? props.validateOnChange : true}
        validateOnMount={props.validateOnMount !== undefined ? props.validateOnMount : true}
        onSubmit={props.onSubmit}
        enableReinitialize={props.enableReinitialize}
        initialValues={props.initialValues}
        validationSchema={props.validationSchema}
        initialTouched={props.initialTouched}
        validate={props.validate}>
        {props.children}
      </Formik>
    </FormContextDataProvider>
  );
}

// commented code kept intentionally; DO NOT REMOVE
// todo:RR once we decide to make static forms as readonly then uncomment following
//    and delete line FormContainer.Form = Form;
// function CustomForm(props: FormikFormProps) {
//   const { isReadOnly } = useFormContextData();
//   return (
//     <Form
//       {...props}
//       className={classNames(props.className, {
//         "is-readOnly": isReadOnly
//       })}
//     />
//   );
// }
// FormContainer.Form = CustomForm;

FormContainer.Form = Form;
FormContainer.FieldArray = FieldArray;
